import { SVG, SVGProps } from './svg'

export function IconGesture(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M20.5 13H19v-1a4 4 0 0 0-4-4c-2.64 0-4 2-5 3.55S8.24 14 7 14a2 2 0 0 1-2-2c0-1.25.89-1.75 2.77-2.52 1.52-.63 3.41-1.4 3.41-3.47a3 3 0 0 0-3-3 5.08 5.08 0 0 0-3.13 1.07 3.39 3.39 0 0 1-1.61.73.5.5 0 0 0-.44.49v1a.52.52 0 0 0 .16.37.56.56 0 0 0 .39.13 5.36 5.36 0 0 0 2.63-1.06 3.07 3.07 0 0 1 2-.74 1 1 0 0 1 1 1c0 .66-.7 1-2.17 1.61C5.32 8.32 3 9.26 3 12a4 4 0 0 0 4 4c2.36 0 3.56-1.77 4.62-3.33S13.53 10 15 10a2 2 0 0 1 2 2v1h-1.84A4.11 4.11 0 0 0 11 17a4 4 0 0 0 4 4 4.11 4.11 0 0 0 4-4.16V15h1.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5ZM17 16.84c0 .43-.36 2.16-2 2.16a2 2 0 0 1-2-2 2.12 2.12 0 0 1 2.16-2H17Z" />
    </SVG>
  )
}
